<template>
    <div class="box-product-info">
        <div class="box-product-top">
            <div class="container">
                <div class="row">
                    <div class="box-product-body">
                        <div class="logo" >
                            <img :src="imgLogo"/>
                          <Hotline/>
                        </div>
                        <div class="box-product-body-top row">
                            <div class="box-product-body-info col-md-6">
                                <div class="product-status">
                                    <span v-html="productStatus"></span>
                                </div>
                                <div class="product-title"> 
                                    <v-clamp autoresize :max-lines="2">{{ productTitle }}</v-clamp>
                                </div>
                                <div class="product-info">
                                    <div class="box-all-info">
                                        <div class="box-item-info">
                                            <div class="box-col-info">
                                                <label>Model</label>
                                                <span class="text-uppercase">{{ productModel }} </span>
                                            </div>
                                            <div class="box-col-info">
                                                <label>Serial number</label>
                                                <span> {{ productSerialNumber }}</span>
                                            </div>
                                            <div class="clearfix"></div>
                                        </div>
                                        <div class="box-item-info">
                                            <div class="box-col-info">
                                                <label>Ngày kích hoạt bảo hành</label>
                                                <span>{{ productDateActive }} </span>
                                            </div>
                                            <div class="box-col-info">
                                                <label>Hiệu lực bảo hành đến ngày</label>
                                                <span>{{ productDateExpired }} </span>
                                            </div>
                                            <div class="clearfix"></div>
                                        </div>
                                        <div class="box-item-info">
                                           <!-- <div class="box-col-info">
                                                <label>Thời hạn Đổi</label>
                                                <span v-html="productChangeTime"></span>
                                            </div>-->
                                            <div class="box-col-info">
                                                <label>Thời hạn bảo hành</label>
                                                <span v-html="productTimeWarranty"> </span>
                                            </div>
                                            <div class="clearfix"></div>
                                        </div>
                                      <div class="box-item-info" style="border-bottom: unset">
                                        <a target="_blank" class="link-policy" :href="productPolicyLink">{{ productPolicy }} <img  :src="imgPolicy"/></a>
                                      </div>
                                      <div class="box-item-info" v-if="!this.$myConstants.isEmpty(link_youtube) || !this.$myConstants.isEmpty(link_pdf)">
                                        <div class="box_help_item" style="">
                                          <div class="help_group_key" style="">
                                            <span class="text_title_help">Hướng dẫn sử dụng:</span>
                                            <div class="item_help item_help_1" style="" v-if="!this.$myConstants.isEmpty(link_pdf)" @click="redirect_lick(link_pdf)" >
                                              <img class="icon_help_common" style="" :src="icon_pdf"/>
                                              <span class="text_help_key" style="">PDF</span>
                                              <img class="icon_help_top" style="" :src="vector_top"/>
                                            </div>
                                            <div class="item_help item_help_2" style="" v-if="!this.$myConstants.isEmpty(link_youtube)" @click="redirect_lick(link_youtube)"  >
                                              <img  class="icon_help_common" style="" :src="youtube_icon"/>
                                              <span class="text_help_key" style="">Youtube</span>
                                              <img class="icon_help_top" style="" :src="vector_top"/>
                                            </div>
                                          </div>


                                        </div>
<!--                                        <div class="box-col-info">
                                          <label>Ngày kích hoạt bảo hành</label>
                                          <span>{{ productDateActive }} </span>
                                        </div>
                                        <div class="box-col-info">
                                          <label>Hiệu lực bảo hành đến ngày</label>
                                          <span>{{ productDateExpired }} </span>
                                        </div>
                                        <div class="clearfix"></div>-->
                                      </div>
                                    </div>
                                </div>

                            </div>
                            <div class="col-md-6">
                                <div class="box-product-body-img">
                                    <div class="box-product-img">
                                        <img v-if="productImg != ''" :src="productImg"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="box-product-body-bottom">
            <div class="container">
                <div class="row">
                    <div class="box-product-body-bottom-board" v-if="productHighlightContent || productAppContent || product_link">
                        <div class="box-highlight" v-if="productHighlightContent">
                            <div class="guide">
                                <img :src="imgLighlight"/>
                                <div class="guide-title" v-html="productHighlight"></div>
                            </div>
                            <div class="guide" v-html="productHighlightContent"></div>
                            <div class="clearfix"></div>
                        </div>
                        <div class="box-product-app" v-if="productAppContent">
                            <div class="guide">
                                <img :src="imgApp"/>
                                <div class="guide-title" v-html="productApp"></div>
                            </div>
                            <div class="guide" >
                                <div class="description" v-html="productAppContent"></div>
                            </div>
                            <div class="clearfix"></div>
                        </div>
                        <div class="box-product-slug" v-if="product_link">
                            <a v-if="product_link" target="_blank" :href="product_link" class="btn-link-open" ><span v-html="productInfo"></span><img :src="imgLinkProduct"/></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
     </div>
</template>

<script>
    import Hotline from './warranty_check_detail_hotline'
    import VClamp from 'vue-clamp'
    import moment from "moment";
    import DataServices from '@/core/DataServices'
    import {constants} from "@/services/constants";
    export default {
        components: {
          Hotline,
          VClamp,
        },
        props: {
            lstData: Array
        },
        data() {
          return {
            youtube_icon: window.origin + '/assets/images/youtube_icon.png',
            vector_top: window.origin + '/assets/images/vector_top.png',
            icon_pdf: window.origin + '/assets/images/icon_pdf.png',
            imgLogo: window.origin + '/assets/images/logo_h_ng_k_.png',
            imgLighlight: window.origin + '/assets/images/group_5476.png',
            imgApp: window.origin + '/assets/images/group_5476-1.png',
            imgPolicy: window.origin + '/assets/images/call_made.png',
            imgLinkProduct: window.origin + '/assets/images/arrow_forward.png',
            productApp: '',
            productHighlight: '',
            productAppContent: '',
            productHighlightContent: '',
            productInfo: '',
            productImg: '',
            productStatus: '',
            productTitle: '',
            productModel: '',
            productSerialNumber: '',
            productDateActive: '- -',
            productDateExpired: '- -',
            productTimeReturn: '- -',
            productTimeWarranty: '- -',
            productChangeTime: '- -',
            productPolicy: '',
            productPolicyLink: '',
            slug: '',
            product_link: '',
            link_pdf:'',
            link_youtube:'',
          }
        },
        mounted () {
            if (this.lstData != undefined && this.lstData && Object.keys(this.lstData).length > 0) {
                var objProductApp = this.lstData.filter(a => a.key == 'PAGE_CHECKER_PRODUCT_APP');
                if (objProductApp && Object.keys(objProductApp).length) {
                    this.productApp = objProductApp[0].value.trim();
                }
                var objProductHighlight = this.lstData.filter(a => a.key == 'PAGE_CHECKER_PRODUCT_HIGHLIGHT');
                if (objProductHighlight && Object.keys(objProductHighlight).length) {
                    this.productHighlight = objProductHighlight[0].value.trim();
                }
               
                var objProductInfo = this.lstData.filter(a => a.key == 'PAGE_CHECKER_PRODUCT_INFO');
                if (objProductInfo && Object.keys(objProductInfo).length) {
                    this.productInfo = objProductInfo[0].value.trim();
                } 

                var objProductPolicy = this.lstData.filter(a => a.key == 'PAGE_CHECKER_PRODUCT_POLICY');
                if (objProductPolicy && Object.keys(objProductPolicy).length) {
                    this.productPolicy = objProductPolicy[0].value.trim();
                }  
                
                var objProductPolicyLink = this.lstData.filter(a => a.key == 'PAGE_CHECKER_PRODUCT_POLICY_LINK');
                if (objProductPolicyLink && Object.keys(objProductPolicyLink).length) {
                    this.productPolicyLink = objProductPolicyLink[0].value.trim();
                }  
            }
            this.checkSerialNumber();
        },
        methods: {
          async redirect_lick(link) {
            //window.location.href = link
            window.open(link);
          },
            async checkSerialNumber() {
                var keyword = this.$route.params.keyword.trim();
                if (keyword.length > 0) {
                    this.productSerialNumber = keyword;
                    var variables1 = {
                        where_key: {
                            serial_number: {'_eq': keyword },
                            production_status: {'_eq': 1},
                            status: {'_eq': 1}
                        }
                    }
                    var data1 = await DataServices.getList('product_serial_number', {"variables": JSON.stringify(variables1), "fields": "warranty_status product { thumbnails { external_path cdn_path local_path} name link_pdf link_youtube model_code returnable_time returnable_unit warranty_time warranty_unit slug product_link desc_product_application desc_product_advantages change_time change_unit} product_serial_number_info { name model_code returnable_time warranty_time warranty_status verify_status activation_date warranty_unit returnable_unit change_time change_unit}"});
                    var list1 = data1[Object.keys(data1)];
                    
                    if (list1 && Object.keys(list1).length > 0) {
                        var item = list1[0];
                        //console.log("itemitem:",item)
                        this.link_youtube = (!constants.isEmpty(item.product.link_youtube)) ? item.product.link_youtube:'';
                        this.link_pdf = (!constants.isEmpty(item.product.link_pdf)) ? item.product.link_pdf:'';
                        if (item.product != undefined && item.product != null && item.product.thumbnails != undefined
                        && item.product.thumbnails != null) {
                            this.productImg = (item.product.thumbnails.external_path != undefined && item.product.thumbnails.external_path != null)  ? item.product.thumbnails.external_path : item.product.thumbnails.cdn_path + item.product.thumbnails.local_path;
                        }
                        
                        if(item.product != undefined && item.product != null) {
                            this.product_link  = item.product.product_link;
                            this.slug  = item.product.slug;
                            this.productAppContent = item.product.desc_product_application;
                            this.productHighlightContent = item.product.desc_product_advantages;
                            this.productTitle = item.product.name;
                            this.productModel = item.product.model_code;
                        }

                        if (item.product_serial_number_info != undefined && item.product_serial_number_info != null) {
                            if (item.product_serial_number_info.activation_date != undefined) {
                                this.productDateActive = moment.tz(item.product_serial_number_info.activation_date, this.$myConstants.timeZone()).format('DD/MM/YYYY');
                                var expiredDate = moment(item.product_serial_number_info.activation_date).add(item.product_serial_number_info.warranty_time, 'M');
                                this.productDateExpired = moment.tz(expiredDate, this.$myConstants.timeZone()).format('DD/MM/YYYY');
                            }
                            if (item.product_serial_number_info.returnable_time != undefined && item.product_serial_number_info.returnable_time != null) {
                                this.productTimeReturn = item.product_serial_number_info.returnable_time + '&nbsp;' + this.$myConstants.switchUnit(item.product_serial_number_info.returnable_unit);
                            }
                            if (item.product_serial_number_info.change_time != undefined && item.product_serial_number_info.change_time != null) {
                              this.productChangeTime = item.product_serial_number_info.change_time + '&nbsp;' + this.$myConstants.switchUnit(item.product_serial_number_info.change_unit);
                            }
                            if (item.product_serial_number_info.warranty_time != undefined && item.product_serial_number_info.warranty_time != null) {
                                this.productTimeWarranty = item.product_serial_number_info.warranty_time + '&nbsp;' + this.$myConstants.switchUnit(item.product_serial_number_info.warranty_unit);
                            }
                            if (item.product_serial_number_info.warranty_status != 3) {
                                this.productDateActive = '- -';
                                this.productDateExpired = '- -';
                            }
                            this.statusText(item.product_serial_number_info, item.product_serial_number_info.warranty_status);
                        } else {
                            if (item.product.returnable_time != undefined && item.product.returnable_time != null) {
                                this.productTimeReturn = item.product.returnable_time + '&nbsp;' + this.$myConstants.switchUnit(item.product.returnable_unit);
                            }
                            if (item.product.change_time != undefined && item.product.change_time != null) {
                              this.productChangeTime = item.product.change_time + '&nbsp;' + this.$myConstants.switchUnit(item.product.change_unit);
                            }
                            if (item.product.warranty_time != undefined && item.product.warranty_time != null) {
                                this.productTimeWarranty = item.product.warranty_time + '&nbsp;' + this.$myConstants.switchUnit(item.product.warranty_unit);
                            }
                            this.statusText(item.product, item.warranty_status);
                        }
                    }
                }
            },
            statusText(item, warrantyStatus) {
                if (warrantyStatus == 0 || warrantyStatus == 5) this.productStatus = 'Chưa kích hoạt';
                else if (warrantyStatus == 2) this.productStatus = 'Chờ kích hoạt';
                else if (warrantyStatus == 4) this.productStatus = 'Hết bảo hành';
                else if (warrantyStatus == 6) this.productStatus = 'Sản phẩm huỷ';
                else if (warrantyStatus == 1 || warrantyStatus == 3) {

                  var dataDateArr = {
                    warranty_time:item.warranty_time,
                    returnable_time:item.returnable_time,
                    change_time:item.change_time,
                    warranty_status:warrantyStatus,
                    activation_date:item.activation_date,
                    arrWarrantyStatus:null,
                    warranty_unit:item.warranty_unit,
                  }
                    var arrs = this.$myConstants.returnDateCustomText(dataDateArr);
                    this.warranty_time = arrs.warranty_time_text1;
                    this.returnable_time = arrs.returnable_time_text1;
                    var change_time_text1 = arrs.change_time_text1;
                    this.productTimeReturn = item.returnable_time + ' ngày <abbr><b></b>' + this.returnable_time + '</abbr>';
                    this.productChangeTime = item.change_time + ' ngày <abbr><b></b>' + change_time_text1 + '</abbr>';

                    this.productStatus = '<abbr>Đã kích hoạt</abbr><abbr class="timeline"><b></b>Còn lại ' + this.warranty_time +'</abbr>';
                }
            }
        }
        
    }
</script>

<style lang="scss">
.box-product-info{
    .box-product-top{ background: #26a2d6; position: relative; 
        .text-uppercase{text-transform: uppercase;}
        .box-product-body{width: 100%; position: relative;  /*margin-bottom: 60px; border: 1px solid #000;*/
            .logo{margin-top:  22.50px; margin-bottom:  48.00px;height: 51px;
                img{width: 60px; height: 51px;float: left;}
            }
            .box-product-body-top{
                .box-product-body-info{
                    .product-status{ line-height: 38px; height: 38px; border-radius: 100px; background: #fff; text-align: center; box-shadow: 0px 4px 16px rgba(28, 28, 30, 0.16);display: inline-block; padding: 0 20px;
                        span{width: 100%; display: block; color: #1c1c1e; font-family: 'Roboto'; font-weight: 700; font-size: 16px;
                            abbr{color: #00ba88;
                                &.timeline{color: #26a2d6; font-family: 'Roboto'; margin-left: 6px; font-weight: normal;
                                    b{position: relative; top: -1px; width: 5px; height: 5px; display: inline-block; border-radius: 50%; margin-right: 5px;background: #26a2d6;}
                                }
                            }
                        }
                    }
                    .product-title{width: 416.25px; margin-top: 12px;font-family: 'Roboto'; font-weight: 700; font-size: 40px; line-height: 130%; color: #fff; min-height:  78.00px;}
                    .link-policy{ color: #fff; text-decoration: underline; margin-top: 17.25px; display: block;font-size: 15px; line-height: 20px;
                        img{width: 16px; height: 16px; margin-left: 5px;}
                    }
                    .product-info{width: 417px;; 
                        .box-all-info{
                            .box-item-info{border-bottom: 1px solid #66bfe4; padding-bottom: 7.5px; margin-bottom: 7.5px;
                                .box-col-info{ min-width: 180px; display: inline-block;
                                    &:first-child{margin-right:37.50px;}
                                    label{font-family: 'Roboto'; color: #E9F6FC; font-size: 12px;line-height: 20px; text-transform: uppercase; display: block; margin-bottom: 1.50px;}
                                    span{display: block; color: #fff; font-family: 'Roboto'; font-weight: 700; font-size: 17px; line-height: 22px;
                                        b{position: relative; top: -3px; width: 3px; height: 3px; display: inline-block; border-radius: 50%; margin: 0 5px;background: #b4e0f3;}
                                        abbr{color: #b4e0f3;  font-family: 'Roboto'; font-weight: normal;}
                                    }
                                }
                                &:last-child{border-bottom: none; padding: 0; margin: 0;}
                            }
                        }
                    }
                }
                .box-product-body-img{ position: relative; height: 100%;width: 100%; display: flex; justify-content: center;
                    .box-product-img{right: 0; position: absolute; margin: 0 auto; width: 500px; height:500px; background: #fff; border-radius: 15px; box-shadow: 0px 15px 10px -5px rgba(28,28,30, 0.15); display: flex; align-items: center; overflow: hidden; justify-content: center;
                        img{ max-width: 100%; height: auto;}
                    }
                }
            }
        }
    }
    .box-product-body-bottom {width: 945px; margin: 0 auto; 
        .guide{float: left; width: 60%; font-size: 17px; line-height: 22px;
            &:first-child{width: 40%;}
            img{width:60px;  display: block;}
            .guide-title{display: block; font-family: 'Roboto';  font-size: 36px; line-height: 42px;
                span{border-bottom: 3px solid #f00; padding-bottom: 15.00px;}
            }
        }
        .box-product-body-bottom-board {margin-top: 60px; margin-bottom: 60px; width: 100%;}
        .box-highlight{  margin-bottom: 37.50px; color: #3a3a3c; font-size: 12.75px; font-family: 'Roboto'; line-height:  16.50px;
            ul{padding: 0; margin: 0;}
            ul li{ list-style: none;  background: url("../../../public/assets/images/check_circle_outline.png") no-repeat left top; background-size: 20px;padding-left: 32px;padding-top: 3px; margin-bottom: 9px;}
        }
        .box-product-app{ color: #3a3a3c; font-size: 12.75px; font-family: 'Roboto'; line-height: 17.85px;
            ul{padding: 0; margin: 0;}
            ul li{ list-style: none;  background: url("../../../public/assets/images/check_circle_outline.png") no-repeat left top; background-size: 20px;padding-left: 32px;padding-top: 3px; margin-bottom: 9px;}
        }
        .box-product-slug{float: right; width: 60%;
            .btn-link-open{margin-top: 22.50px; text-decoration: none;  width: 329px; height: 48px; border-radius: 100px; background: linear-gradient(72.93deg, #26A2D6 16.15%, #5BC3EE 100%); display: flex; align-items: center;   justify-content: center; box-shadow: 0 10px 10px -5px #3faedc;
                span{color: #fff; text-transform: uppercase; margin-right: 6.38px; display: inline-block;font-weight: 500; font-size: 15px; line-height: 22px;}
                img{width: 16.50px; height: 16.50px;}
            }
        }
    } 
}
.text_title_help{
  font-family: 'Roboto'; font-style: normal; font-weight: 700; font-size: 17px;
}
.help_group_key{
  align-items: center!important;display: flex!important;height: 100%; line-height: 22px; color: #FFFFFF; padding-left: 20px;
}
.box_help_item{
  height: 38px;background: rgba(255, 255, 255, 0.2); /* Primary / Blue / 2 */ border: 1px solid #8DCFEB; border-radius: 100px;
  .item_help{
    cursor: pointer;height: 24px; display: inline;margin-left: 20px;
    .icon_help_common{
      width: 24px; height: 24px;
    }
    .text_help_key{
      text-decoration: underline;margin-left: 8px;font-family: 'Roboto'; font-style: normal; font-weight: 500; font-size: 15px; line-height: 20px;
    }
    .icon_help_top{
      width: 10px; height: 10px;margin-left: 8px
    }
  }
}
@media (max-width: 991px) {
.text_title_help{
  font-size: 12px;
}
  .text_help_key{
    font-size: 12px !important;
  }
  .item_help{
    margin-left: 10px !important;
  }
}
@media (max-width: 767px) {
  .text_title_help{
    font-size: 17px !important;
  }
  .text_help_key{
    font-size: 15px !important;
  }
  .item_help{
    margin-left: 50px !important;
  }
}

@media (max-width: 480px) {
  .text_title_help{
    font-size: 17px !important;
  }
  .text_help_key{
    font-size: 15px !important;
  }
  .item_help{
    margin-left: 20px !important;
  }
}
@media (max-width: 430px) {
  .help_group_key{
    padding-left: 20px !important;
  }
  .text_title_help{
    font-size: 14px !important;
  }
  .text_help_key{
    font-size: 14px !important;
  }
  .item_help{
    margin-left: 12px !important;
  }
}
@media (max-width: 380px) {
  .help_group_key{
    padding-left: 12px !important;
  }
  .text_title_help{
    font-size: 12px !important;
  }
  .text_help_key{
    font-size: 12px !important;
  }
}
@media (max-width: 350px) {
  .help_group_key{
    padding-left: 12px !important;
  }
  .item_help{
    margin-left: 4px !important;
  }
}
@media (max-width: 350px) {
  .help_group_key{
    padding-left: 12px !important;
  }
  .text_title_help{
    font-size: 12px !important;
  }
  .text_help_key{
    font-size: 10px !important;
  }
}
</style>